import './DetailSubsection.scss';

import classNames from 'classnames';
import { getTitleWithCount } from '@sonar-software/sonar-ts-lib';

import React, { PropsWithChildren } from 'react';
import { Row, Space } from 'antd';

export interface DetailSubsectionProps {
	className?: string;
	count?: number;
	headerSpaceAlign?: 'center' | 'start' | 'end' | 'baseline';
	hidden?: boolean;
	spacing?: 'none' | 'small' | 'medium' | 'large';
	title: string;
	titleExtra?: React.ReactNode;
}

export const DetailSubsection: React.FC<PropsWithChildren<DetailSubsectionProps>> = ({
	children,
	count,
	headerSpaceAlign = 'center',
	hidden,
	className,
	spacing = 'medium',
	title,
	titleExtra
}) => {
	if (hidden) {
		return null;
	}

	return (
		<div className={ classNames('detail-subsection', className) }>
			<Row
				align='middle'
				className='h3 detail-subsection-header'>
				<Space align={ headerSpaceAlign }>
					<span className='detail-subsection-title'>{ getTitleWithCount(title, count) }</span>
					{ titleExtra }
				</Space>
			</Row>
			<div
				className={ classNames('detail-subsection-body', {
					'detail-subsection-body-large-spacing': spacing === 'large',
					'detail-subsection-body-no-spacing': spacing === 'none',
					'detail-subsection-body-small-spacing': spacing === 'small'
				}) }>
				{ children }
			</div>
		</div>
	);
};
